import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-organization-information',
  templateUrl: './organization-information.component.html',
  styleUrls: ['./organization-information.component.scss']
})
export class OrganizationInformationComponent implements OnInit {

  formGroup: FormGroup;
  @Output() onCreateForm: EventEmitter<FormGroup>;

  industryTypes: string[] = [
    'Agency',
    'K12',
    'Individual',
    'OBM',
    'Insurance',
    'University',
    'Other'
  ];

  objectKeys = Object.keys;

  regulationTypes: {[s: string]: string} = {
    'US': 'United States',
    'CA': 'Canada',
    'EU': 'European Union',
    'Other': 'Other / Multiple'
  };

  constructor(fb: FormBuilder) {
    this.formGroup = fb.group({
      orgName: new FormControl("", Validators.required),
      studentCount: new FormControl("", [this.studentCountValidator, Validators.required]),
      industry: new FormControl("Agency", Validators.required),
      regulations: new FormControl("US", Validators.required)
    });

    this.onCreateForm = new EventEmitter<FormGroup>();
   }

  ngOnInit() {

  }

  onAddressFormCreated(formGroup: FormGroup) {
    this.formGroup.addControl('address', formGroup);
    this.onCreateForm.emit(this.formGroup);
  }


  studentCountValidator(control: FormControl): { [s: string]: boolean } {
    if (!control.value.match(/[0-9]*/)) {
      return {'Please enter a number': true};
    }
  }

  limitStudentCountChars(control: FormControl) {
    if(control instanceof FormControl) {
      control.setValue(control.value.replace(/[^0-9]+/, ""));
    }
  }


    

}
